import React from "react"
import VideoCarousel from "../../components/ReusableComponents/VideoCarousel/VideoCarousel"
import ApiURL from "../../services/ApiURL"
import { CarouselDataApi, LiveAndUpcomingApi } from "../../services/CallApi"
import PropTypes from "prop-types"
import CarouselZeroState from "../../components/ReusableComponents/CarouselZeroState/CarouselZeroState"
import { ErrorUI } from "../../components/UI/Modals/Modals"

const CarouselHoc = (WrappedComponent, showClassTile) => {
  return class extends React.Component {
    state = {
      videoTiles: [],
    }

    componentDidMount() {
      //console.log("this.props.apiData", this.props);
      if (this.props.shouldHitApi) {
        if (showClassTile) {
          this.getBookedActivities(this.props.gymIds, this.props.status)
        } else {
          this.getCarouselData(this.props.gymIds)
        }
      } else if (this.props.apiData.length) {
        this.setState({ videoTiles: [...this.props.apiData] })
      }
    }

    componentDidUpdate(prevProps) {
      if (
        (this.props.apiData.length && !this.state.videoTiles.length) ||
        prevProps.apiData.length !== this.props.apiData.length
      ) {
        this.setState({ videoTiles: [...this.props.apiData] })
      }
      if (prevProps.gymIds !== this.props.gymIds) {
        if (this.props.shouldHitApi) {
          if (showClassTile) {
            this.getBookedActivities(this.props.gymIds, this.props.status)
          } else {
            this.getCarouselData(this.props.gymIds)
          }
        } else if (this.props.apiData.length) {
          this.setState({ videoTiles: [...this.props.apiData] })
        }
      }
    }

    getBookedActivities = (gymIds, status = []) => {
      const data = {
        limit: 10,
        offset: 0,
        gym_ids: JSON.stringify(gymIds),
      }
      if (status.length) {
        data["activity_status"] = status
      }
      LiveAndUpcomingApi(ApiURL[this.props.url], data).then((res) => {
        if (res.status) {
          this.setState({
            videoTiles: [...res.list],
          })
        } else {
          ErrorUI(res.list, () => this.getBookedActivities(gymIds, status))
        }
      })
    }

    getCarouselData = (gymIds) => {
      const payload = {
        limit: 20,
        offset: 0,
        gym_ids: JSON.stringify(gymIds),
        is_gym_status_pending: false,
      }
      CarouselDataApi(ApiURL[this.props.url], payload).then((res) => {
        if (res.status) {
          this.setState({ videoTiles: [...res.list] })
        } else {
          console.log(res)
          ErrorUI(res.list, () => this.getCarouselData(gymIds))
        }
      })
    }

    render() {
      const videoTilesUI = this.state.videoTiles.map((el, index) => (
        <WrappedComponent
          key={el.activity_id}
          tileSize={this.props.tileSize}
          showNewTag={this.props.showNewTag}
          showTrend={this.props.showTrend}
          index={index}
          {...el}
        />
      ))
      return (
        <React.Fragment>
          {videoTilesUI.length ? (
            <VideoCarousel
              heading={this.props.heading}
              showExploreAll={this.props.showExploreAll}
            >
              {videoTilesUI}
            </VideoCarousel>
          ) : (
            <React.Fragment>
              {this.props.zeroStateText ? (
                <CarouselZeroState text={this.props.zeroStateText} />
              ) : null}
            </React.Fragment>
          )}
        </React.Fragment>
      )
    }
  }
}

export default CarouselHoc

React.Component.propTypes = {
  tileSize: PropTypes.string.isRequired,
  url: PropTypes.string,
  apiData: PropTypes.array,
  showExploreAll: PropTypes.bool,
  showClassTile: PropTypes.bool,
  shouldHitApi: PropTypes.bool,
  zeroStateText: PropTypes.string,
}

React.Component.defaultProps = {
  tileSize: "large",
  url: null,
  apiData: [],
  showExploreAll: false,
  showClassTile: false,
  shouldHitApi: true,
  zeroStateText: null,
}
